import api from "./httpService";

export const getCoachesService = async () => {
    const response = await api.get("/coaches");
    return response.data;
};
